export function tentativeServicesFromSection(tentativeSection) {
    let tentativeServices = [];
    tentativeSection.tentativeServices.forEach((tentativeService) => {
        tentativeServices.push(tentativeService);
    });
    return tentativeServices;
}

export function tentativeSectionsFromPackage(tentativePackage) {
    let tentativeSections = [];
    tentativePackage.tentativeSections.forEach((tentativeSection) => {
        tentativeSections.push(tentativeSection);
    });
    return tentativeSections;
}

export function tentativeServicesFromPackage(tentativePackage) {
    let tentativeServices = [];
    tentativeSectionsFromPackage(tentativePackage).forEach((tentativeSection) => {
        tentativeServices = tentativeServices.concat(tentativeServicesFromSection(tentativeSection));
    });
    return tentativeServices;
}

export function tentativePackagesFromTentatives(tentatives) {
    return tentatives['packages'];
}

export function tentativeSectionsFromTentatives(tentatives) {
    let tentativeSections = [];
    Object.keys(tentatives).forEach((key) => {
        if (key === 'packages') {
            tentatives[key].forEach((tentativePackage) => {
                tentativeSections = tentativeSections.concat(tentativeSectionsFromPackage(tentativePackage));
            });
        } else {
            tentatives[key].forEach((tentativeSection) => {
                tentativeSections.push(tentativeSection);
            });
        }
    });
    return tentativeSections;
}

export function tentativeServicesFromTentatives(tentatives) {
    let tentativeServices = [];
    Object.keys(tentatives).forEach((key) => {
        if (key === 'packages') {
            tentatives[key].forEach((tentativePackage) => {
                tentativeServices = tentativeServices.concat(tentativeServicesFromPackage(tentativePackage));
            });
        } else {
            tentatives[key].forEach((tentativeSection) => {
                tentativeServices = tentativeServices.concat(tentativeServicesFromSection(tentativeSection));
            });
        }
    });
    return tentativeServices;
}
